import axios from 'axios';
import React, { useState } from 'react'
import { toast } from 'react-toastify';
import * as CONSTANTS from "../../CONSTANTS";

function AdminGalleryUpdates({currentAnnisite, setCurrentAnnisite, user, setUpdateAction}) {

    const [featuredImage, setFeaturedImage]                    = useState(null); 
    const [ process, setProcess]                            = useState(false);
    
    const [processing, setProcessing]                 = useState(false);
    const [selectedFiles, setSelectedFiles]           = useState([]);
    const [uploadStatus, setUploadStatus]             = useState({});
    const [successCount, setSuccessCount]             = useState(0);

    const handleChange = (e) => {
        setFeaturedImage(e.target.files[0]); // save the file object
    };

    const handleSubmitFeatured = async (e) => {
        e.preventDefault();
        if (!featuredImage) {
            toast.warning("Please select an image first.");
            return;
        }
        
        try {

            setProcess(true);
            const formData = new FormData();
            formData.append("featureUrl", featuredImage);
            formData.append('eventId', currentAnnisite._id);
            formData.append('cloudinaryId', currentAnnisite.cloudinaryId)

            const result = await axios.post(`${CONSTANTS.API_URL}annivites/onvite/update-detais/with-image/v1`, formData, {
                    headers: { 
                    "Content-Type": "multipart/form-data" ,
                    token: 'Bearer ' + user.accessToken,
                    }
                });
                
            toast.success("Thank you, the profile picture was updated.");
            setCurrentAnnisite(result.data);
             setProcess(false);
        } catch (err) {
            console.error("Upload failed:", err);
            setProcess(false);
            toast.error("Something went wrong, please try again later.");
        }
    }

    ////////////////////////
      
    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
            setSelectedFiles(files);
            setUploadStatus({});
            setSuccessCount(0);
    };

    const handleUpload = async () => {
        if (!currentAnnisite?._id || selectedFiles.length === 0) {
        toast.warn("Please select images and ensure the event is selected.");
        return;
        }

        let currentSuccessCount = 0;
        const statusObj = {};

        for (let i = 0; i < selectedFiles.length; i++) {
        const formData = new FormData();
        formData.append("eventId", currentAnnisite._id);
        formData.append("imageCatalogue", selectedFiles[i]);

        statusObj[selectedFiles[i].name] = 'uploading';
        setUploadStatus({ ...statusObj });

        try {
            setProcessing(true)
            const response = await axios.post(`${CONSTANTS.API_URL}annivites/onvite/upload-catalogue/v1/image`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        token: 'Bearer ' + user.accessToken,
                    },
                });

            if (response.status === 200) {
            statusObj[selectedFiles[i].name] = 'success';
            currentSuccessCount++;
            setUpdateAction(prev => prev + 1);
            
            } else {
            statusObj[selectedFiles[i].name] = 'error';
            }
            setProcessing(false)
        } catch (err) {
            setProcessing(false)
            statusObj[selectedFiles[i].name] = 'error';
        }

        setUploadStatus({ ...statusObj });
        setSuccessCount(currentSuccessCount);
        }

        toast.success("Upload process completed");
        setSelectedFiles([]);   
    };

    const handleDeleteThisImage = async (catalogueId) => {
        try {

            const deleteEvent = {
                "eventId" : currentAnnisite._id,
                "catalogueId" : catalogueId
            }

            const response = await axios.put(`${CONSTANTS.API_URL}annivites/onvite/delete-catalogue/v1/image`, deleteEvent, {
                    headers: {
                        token: 'Bearer ' + user.accessToken,
                    },
                });

            
            toast.success(response.data.message);
            setUpdateAction((prev) => prev - 1);

        }catch(err){
            console.log(err);
            toast.error("Could not delete, please try again later.")
        }
    }
  return (
    <div className="container mt-4">
      
        <div className="dotted-section pt-3">
            <h3>Update Featured Image</h3>
                <form onSubmit={handleSubmitFeatured}>
                    <div className="pt-3">
                    <input
                        type="file"
                        name="featureUrl"
                        accept="image/*"
                        onChange={handleChange}
                    />
                    </div>
                    <button type="submit" className="btn btn-primary mt-3" disabled={process}>
                       {
                        process ? "processing..." : "Upload"
                       }
                    </button>
                </form>
        </div>

        <div className="dotted-section pt-3">
            <h3>Proposal Catalogue</h3>
            
            <div className="list-couple">
            {
                currentAnnisite.weddingOnviteCatalogue.length > 0 && (
                    <div className="row row-unset">
                        {
                        currentAnnisite.weddingOnviteCatalogue.map((catalogue, index) => {
                            return <div className="col-md-4" key={index}>
                                    <div className="image-box">
                                        <button
                                            onClick={() => handleDeleteThisImage(catalogue.cloudinaryid)} 
                                            className="btn Bclose btn-close">
                                        
                                        </button>
                                        <img src={catalogue.url} className="img-catalogue" alt={"LoveDripp Couple " + currentAnnisite.spouseA + " " + currentAnnisite.spouseB} />
                                    </div>
                                </div>} 
                                )
                                    }
                                </div>
                            )
                        }
                    
                        </div>
                        <div className="form-group mt-3">
                            <input
                            type="file"
                            className="form-control"
                            accept="image/*"
                            multiple
                            onChange={handleFileChange}
                            required
                            />
                        </div>

                        <button 
                            className="btn btn-primary mt-2" onClick={handleUpload}
                            disabled={processing}>
                            Upload Images
                        </button>

                        <div className="upload-status mt-3">
                            {
                                Object.keys(uploadStatus).length > 0 && (
                                <>
                                    <h6>Status Summary</h6>
                                    <ul>
                                    {selectedFiles.map((file) => (
                                        <li key={file.name}>
                                        {file.name} - <strong>{uploadStatus[file.name]}</strong>
                                        </li>
                                    ))}
                                    </ul>
                                    <p>✅ Success Count: <strong>{successCount}</strong></p>
                                </>
                                )
                            }
                        </div>
        </div>
    </div>
  )
}

export default AdminGalleryUpdates